import React, { Component } from "react"
import LeftArrow from "../images/arrow-slider-left.svg"
import RightArrow from "../images/arrow-slider-right.svg"

class LandingHero extends Component {




  render() {
    const layout = this.props.content
    return (
      layout.field_description_wysiwyg !== null ? (
        <div className="container">
          <div data-uk-grid className="uk-child-width-1-2@m">
            <div className="page-311-hero-left-column">
              <div dangerouslySetInnerHTML={{ __html: layout.field_description_wysiwyg.value }} />
               <div className="uk-flex uk-flex-row page-311-hero-left-column-buttons-wrp">
                {layout.relationships.field_links_buttons && layout.relationships.field_links_buttons.map( (button,key) => (
                  <div className="button-wrp" key={`landing-hero-btn-${key}`}>
                    {button.field_link ? (
                        <>
                          {button.field_link?.uri.includes("internal:#") && button.field_link?.uri === 'internal:#chat-with-bot' ?
                            <a className="uk-button green-bgr page-311-button-hero" href={`#`} data-uk-toggle={`target: ${button.field_link?.uri.replace("internal:", "")}`}>
                              {button.field_link?.title}
                            </a>
                            :
                            <a className="uk-button green-bgr page-311-button-hero" href={button.field_link?.uri.includes("internal:") ? button.field_link?.uri.replace("internal:", "") : button.field_link?.uri}>
                              {button.field_link?.title}
                            </a>
                          }
                          {button.field_link?.uri && button.field_link?.uri.includes("internal:#") &&
                            <div id={button.field_link?.uri.split("internal:#")[1]} className="uk-flex-top" data-uk-modal>
                                <div className="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
                                  <button className="uk-modal-close-default" type="button" data-uk-close></button>
                                  <h2 className="uk-modal-title">Chat with Will</h2>
                                  <p>Click the <span><strong>chat icon in the bottom right corner</strong></span> to start chatting with Will. Get instant answers anytime.</p>
                                </div>
                            </div>
                          }
                        </>
                    ) : (
                      null
                    )}

                  </div>

                ))}
              </div>
            </div>
            <div className="uk-position-relative page-311-hero-right-column uk-flex uk-flex-center uk-flex-right@m">
              {layout.relationships?.field_media_image?.relationships?.field_media_image ? (
                <img src={layout.relationships?.field_media_image?.relationships?.field_media_image?.uri.url} alt={layout.relationships?.field_media_image?.relationships?.field_media_image.filename} />
              ) : (
                null
              )}

            </div>
          </div>

        </div>
      ) : (
        null
      )
    )
  }
}

export default LandingHero
